import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import UpdateIcon from '@material-ui/icons/Update';
import Alert from '@material-ui/lab/Alert';
import Collapse from '@material-ui/core/Collapse';
import SunEditor from 'suneditor-react';
import 'suneditor/dist/css/suneditor.min.css'; // Import Sun Editor's CSS File
import { XMEI_PRIMARY_COLOR } from '../../consts/common';
import { instanceAxios } from '../../InstanceAxios';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },
}));

function DescontoIndicacao() {
  const classes = useStyles();

  const [descontoIndicador, setDescontoIndicador] = useState(0);
  const [descontoIndicado, setDescontoIndicado] = useState(0);
  const [descontoTexto, setDescontoTexto] = useState('');
  const [alert, setAlert] = useState(false);
  const [message, setMessage] = useState('');
  const [tipoAlert, setTipoAlert] = useState('');

  useEffect(() => {
    const fetchParams = async () => {
      await instanceAxios(localStorage.getItem('toobiauth'))
        .get(`/descontos`)
        .then((res) => {
          setDescontoIndicado(parseInt(res.data.descontoIndicado.valor));
          setDescontoIndicador(parseInt(res.data.descontoIndicador.valor));
          setDescontoTexto(res.data.descontoTexto.valor);
        })
        .catch((err) => {
          console.log(err);
        });
    };

    fetchParams();
  }, []);

  const handleValor = (valor, tipo) => {
    const novoValor = valor > 0 ? parseInt(valor) % 101 : 0;

    switch (tipo) {
      case 'indicador':
        setDescontoIndicador(novoValor);
        break;
      case 'indicado':
        setDescontoIndicado(novoValor);
        break;
      default:
        break;
    }
  };

  const handleUpdate = async () => {
    await instanceAxios(localStorage.getItem('toobiauth'))
      .post(`/descontos`, {
        desconto_indicado: descontoIndicado,
        desconto_indicador: descontoIndicador,
        desconto_texto: descontoTexto,
      })
      .then((res) => {
        setMessage('Atualizado com Sucesso!');
        setTipoAlert('success');
        setAlert(true);
      })
      .catch((err) => {
        console.log(err);
        setMessage('Erro ao atualizar!');
        setTipoAlert('error');
        setAlert(true);
      });
  };

  const handleChange = (cont) => setDescontoTexto(cont);

  return (
    <>
      <Grid container className={classes.root}>
        <Grid item key="Titulo" lg={12} md={12} sm={12} xl={12} xs={12}>
          <div align="center">
            <h1>Desconto Indicação</h1>
          </div>
        </Grid>
        <Collapse in={alert}>
          <Alert severity={tipoAlert} onClick={() => setAlert(false)}>
            {message}
          </Alert>
        </Collapse>
      </Grid>
      <Grid container className={classes.root} style={{ marginTop: '3%' }}>
        <Grid item key="Indicador" lg={5} md={5} sm={12} xl={12} xs={12}>
          <FormControl>
            <InputLabel htmlFor="indicador">Desconto Indicador</InputLabel>
            <Input
              label="indicador"
              id="indicador"
              type="number"
              value={descontoIndicador}
              onChange={(event) => handleValor(event.target.value, 'indicador')}
              endAdornment={<InputAdornment position="end">%</InputAdornment>}
              aria-describedby="standard-weight-helper-text"
              inputProps={{
                'aria-label': 'Desconto Indicador',
              }}
            />
            <FormHelperText>
              Desconto do usuário que indicar um novo usuário. Esse Desconto
              será aplicado no próximo pagamento de assinatura, caso já tenha um
              desconto aquele mês, desconto é aplicado no próximo.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid item lg={2} md={2} sm={12} xl={12} xs={12} />
        <Grid item key="Indicado" lg={5} md={5} sm={12} xl={12} xs={12}>
          <FormControl>
            <InputLabel htmlFor="indicado">Desconto Indicado</InputLabel>
            <Input
              id="indicado"
              label="Indicado"
              value={descontoIndicado}
              type="number"
              onChange={(event) => handleValor(event.target.value, 'indicado')}
              endAdornment={<InputAdornment position="end">%</InputAdornment>}
              aria-describedby="standard-weight-helper-text"
              inputProps={{
                'aria-label': 'Desconto Indicado',
              }}
            />
            <FormHelperText>
              Desconto para o novo usuário que entrar na XMEI através de um
              código de indicação. Esse desconto é aplicado no primeiro
              pagamento da assinatura do cliente.
            </FormHelperText>
          </FormControl>
        </Grid>
        <Grid
          item
          lg={12}
          md={12}
          sm={12}
          xl={12}
          xs={12}
          style={{ paddingTop: '5%' }}
        >
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <h2 htmlFor="texto">Texto Desconto</h2>
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            <SunEditor
              lang="pt_br"
              setContents={descontoTexto}
              setOptions={{
                height: 200,
                buttonList: [
                  [
                    'undo',
                    'redo',
                    'font',
                    'fontSize',
                    'formatBlock',
                    'paragraphStyle',
                    'blockquote',
                    'bold',
                    'underline',
                    'italic',
                    'strike',
                    'subscript',
                    'superscript',
                    'fontColor',
                    'hiliteColor',
                    'textStyle',
                    'removeFormat',
                    'outdent',
                    'indent',
                    'align',
                    'horizontalRule',
                    'list',
                    'lineHeight',
                    'codeView',
                  ],
                ],
              }}
              onChange={handleChange}
            />
          </div>
        </Grid>
        <Grid item lg={12} md={12} sm={12} xl={12} xs={12}>
          <div align="center" style={{ paddingTop: '5%' }}>
            <Button
              variant="contained"
              style={{
                backgroundColor: XMEI_PRIMARY_COLOR,
                color: '#FFF',
              }}
              startIcon={<UpdateIcon />}
              onClick={handleUpdate}
            >
              Atualizar
            </Button>
          </div>
        </Grid>
      </Grid>
    </>
  );
}

export default DescontoIndicacao;
